import { BaseState } from "..";
import { LoadingState } from "types";
import { PaginatedDtoOfMergedProjectDto, SortDirections, WorkdayProjectDto } from "app/ApiClient";
import { ClientDto, PageContextOfWorkdayProjectsFilter } from "app/SharedApiClient";
import { WorkdayProjectDataTableConfig } from "const/workdayProjectsVariables";

export interface IWorkdayData extends PaginatedDtoOfMergedProjectDto {
  allData: WorkdayProjectDto[];
  pageData: WorkdayProjectDto[];
}

export interface WorkdayProjectState extends BaseState {
  loading: LoadingState;
  data: ClientDto[] | null;
  projectsBysearch?: WorkdayProjectDto[] | null;
  isCreateWorkdayProjectDialogOpened: boolean;
  pageContext: PageContextOfWorkdayProjectsFilter;
  processing: boolean;
  finished: boolean;
  failed: boolean;
  succeed: boolean;
  error: string;
  isUpdateDialog: boolean;
  currentProjectId: number;
  getListLoading: LoadingState;
  createWorkdayProjectLoading: LoadingState;
  updateWorkdayProjectLoading:LoadingState;
  getProjectLoadingState: LoadingState,
  workdayProjects: IWorkdayData;
  filters?: { [key in keyof WorkdayProjectDto]: string[] };
  createAssignWorkdayProjectLoading: LoadingState;
  currentWorkdayProject: WorkdayProjectDto | null;
}

export const initialPageContext: PageContextOfWorkdayProjectsFilter = {
  page: {
    pageSize: WorkdayProjectDataTableConfig.DefaultPageSize,
    pageNumber: WorkdayProjectDataTableConfig.DefaultPageNumber,
  },
  filter: { search: "" },
  sortList: [{ directions: SortDirections.Desceding, field: "createdAt" }],
};

export const initialWorkdayProjectState: WorkdayProjectState = {
  loading: LoadingState.idle,
  data: null,
  projectsBysearch: null,
  isCreateWorkdayProjectDialogOpened: false,
  pageContext: initialPageContext,
  processing: false,
  finished: false,
  failed: false,
  succeed: false,
  error: "",
  isUpdateDialog: false,
  currentProjectId: 0,
  getProjectLoadingState: LoadingState.idle,
  getListLoading: LoadingState.idle,
  createWorkdayProjectLoading: LoadingState.idle,
  updateWorkdayProjectLoading: LoadingState.idle,
  workdayProjects: {
    allData: [],
    pageData: [],
  },
  createAssignWorkdayProjectLoading: LoadingState.idle,
  currentWorkdayProject: null,
};
